export enum CommonEditor {
  CreateDocTitle = '/3RT',
  EditDocTitle = 'i+Vy',
}
